export const threeSixtyDialogCategories = [
	{ label: 'Automotive', value: 'Automotive' },
	{ label: 'Beauty, Spa and Salon', value: 'Beauty, Spa and Salon' },
	{ label: 'Clothing and Apparel', value: 'Clothing and Apparel' },
	{ label: 'Education', value: 'Education' },
	{ label: 'Entertainment', value: 'Entertainment' },
	{ label: 'Event Planning and Service', value: 'Event Planning and Service' },
	{ label: 'Finance and Banking', value: 'Finance and Banking' },
	{ label: 'Food and Grocery', value: 'Food and Grocery' },
	{ label: 'Public Service', value: 'Public Service' },
	{ label: 'Hotel and Lodging', value: 'Hotel and Lodging' },
	{ label: 'Medical and Health', value: 'Medical and Health' },
	{ label: 'Non-profit', value: 'Non-profit' },
	{ label: 'Professional Services', value: 'Professional Services' },
	{ label: 'Shopping and Retail', value: 'Shopping and Retail' },
	{ label: 'Travel and Transportation', value: 'Travel and Transportation' },
	{ label: 'Restaurant', value: 'Restaurant' },
	{ label: 'Other', value: 'Other' },
]

export const whatsAppCloudCategories = [
	{ value: 'UNDEFINED', label: 'None' },
	{ value: 'OTHER', label: 'Other' },
	{ value: 'AUTO', label: 'Automative' },
	{ value: 'BEAUTY', label: 'Beauty, Spa and Salon' },
	{ value: 'APPAREL', label: 'Clothing and Apparel' },
	{ value: 'EDU', label: 'Education' },
	{ value: 'ENTERTAIN', label: 'Entertainment' },
	{ value: 'EVENT_PLAN', label: 'Event Planning and Service' },
	{ value: 'FINANCE', label: 'Finance and Banking' },
	{ value: 'GROCERY', label: 'Food and Grocery' },
	{ value: 'GOVT', label: 'Public Service' },
	{ value: 'HOTEL', label: 'Hotel and Lodging' },
	{ value: 'HEALTH', label: 'Medical and Health' },
	{ value: 'NONPROFIT', label: 'Non-profit' },
	{ value: 'PROF_SERVICES', label: 'Professional Services' },
	{ value: 'RETAIL', label: 'Shopping and Retail' },
	{ value: 'TRAVEL', label: 'Travel and Transportation' },
	{ value: 'RESTAURANT', label: 'Restaurant' },
	{ value: 'NOT_A_BIZ', label: 'Not a business' },
]
